const blackList = ['Script error.', 'could not resolve referenceid for engagment'];
const validMessage = (message) => {
    return blackList.every((blackListItem) => message.toLowerCase().indexOf(blackListItem.toLowerCase()) === -1);
};
let numberOfLogs = 0;
const logClientError = (clientError) => {
    const { message = '' } = clientError;
    if (numberOfLogs++ < 5 && validMessage(message)) {
        return fetch('/platform-metrics/client-errors', { method: 'POST', body: JSON.stringify(clientError) }).catch(() => {
            console.warn('Failed sending error to server');
        });
    }
    return Promise.resolve(false);
};
export { logClientError };
